import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	configurePropertiesAction: {
		id: 'polaris-common.snippet.dropdown-actions.configure-properties-action',
		defaultMessage: 'Configure properties',
		description: 'Configure properties button',
	},
});
